<!--用户统计[代理商用户活跃榜:某个时间段新增的用户数]-->
<template>
    <viewTable
        ref="viewTableRef"
    />
</template>

<script>
import viewTable from "./template/viewTable";
export default {
    name: "userNum",
    components:{
        viewTable
    },
    data(){
        return {
            lang:this.$lang.getLang('agentStatistics','userNum'),
        }
    },
    methods:{

    },
    mounted() {
        this.$refs.viewTableRef.init('AgentReport.report/getUserNumReport');
        // this.$refs.viewTableRef.explain = '用于统计某个时间段下级代理商新增的用户数量';
        this.$refs.viewTableRef.explain = this.lang['explain'];
    }
}
</script>

<style scoped>

</style>